import { serverTimestamp, Timestamp } from 'firebase/firestore';
import { toTitleCase, normalizePhone } from '../sharedFunction';
import moment from 'moment';

const createNote = (lead, customerAppointmentDate) => {
  return `- Token: ${lead['Token'] || ''}
- Tag: ${lead['Tag'] || ''}
- Data Appuntamento ${customerAppointmentDate || ''}
- Filiale: ${lead['filiale'] || ''}`;
};

const compassCaringImportLead = (lead) => {
  const customerAppointmentDate = moment(lead['data_appuntamento']).isValid()
    ? moment(lead['data_appuntamento']).toDate()
    : null;

  return {
    externalId: lead['op_id'],
    firstName: toTitleCase(lead['Nome'].trim()),
    lastName: toTitleCase(lead['Cognome'].trim()),
    ...(lead['CF'] &&
      lead['CF'].trim() !== '' && {
        fiscalCode: lead['CF'].trim(),
      }),
    ...(lead['Email'] &&
      lead['Email'].trim() !== '' && {
        email: lead['Email'].trim(),
      }),
    phone: normalizePhone(lead['Cellulare']),
    ...(customerAppointmentDate && {
      customerAppointmentDate: Timestamp.fromDate(customerAppointmentDate),
    }),
    note: createNote(lead, customerAppointmentDate),
    createdAt: serverTimestamp(),
  };
};

export default compassCaringImportLead;
